import React from "react";
import PageComponent from "js/components/pages/PageComponent";
import AppUser from "js/stores/AppUser";
import AppContent from "js/components/AppContent";
import Constraint from "js/components/Constraint";
import {Link} from "@reach/router";
import {navigate,url} from "js/services/Network";
import {Button} from "reactstrap";


export default class SPPOnboardSignupSuccess extends PageComponent {
  constructor(props) {
    super(props);
    this.state = {
      success: true
    }
  }
  pageName = 'SPPOnboardSignupSuccess';
  pageEvent = () => {
    if (AppUser.isLoggedIn){

    }
  }

  redirect = (link,props,params) => navigate(url(link,props,params));

  buttonCTA = (cta,link) => {
    this.redirect(link);
  }
  renderPage() {
    const alias = localStorage.getItem('ALIAS')?localStorage.getItem('ALIAS'):null;

    return (
      <AppContent className="seller-link-page" padded>
        <div className="pod-container">
          <div className="tw-flex tw-justify-center tw-pt-32 tw-px-6">
            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-max-w-xl tw-gap-6">
              <h5 className="tw-text-center tw-font-semibold tw-text-2xl tw-text-primary">
                Success
              </h5>
              <img
                src="/images/ssp/success.png"
                alt="success-img"
                className="tw-w-[74px] tw-h-[74px]"
              />
              <p className="tw-text-center tw-text-[#2C353CB2]">
                Welcome to Payondelivery(POD). POD Partnership Program is dependent on sales volume. Sell more to qualify.
              </p>
              <button className="btn btn-pod tw-bg-secondary tw-py-3 tw-w-full tw-rounded-lg tw-mt-6 tw-text-white"
                onClick={() => navigate(url('psp-onboard', '',''))}>
                <img
                  src="/images/icons/grid.svg"
                  alt="shop"
                  className="size-24px"
                />&nbsp;&nbsp;
                Become a POD seller partner
              </button>
              <div className="tw-mt-12 tw-flex tw-items-center tw-justify-center tw-max-w-xl">
                <button className="btn btn-pod btn-third tw-py-3 tw-rounded-lg tw-mt-6 tw-text-black tw-pr-5 tw-pl-5 btn-sm tw-text-sm"
                        onClick={() => navigate(url('create-payment-link-page', { step: null },''))}>
                  <img
                    src="/images/icons/items.svg"
                    alt="items"
                    className="size-24px"
                  />
                  &nbsp;&nbsp;Create an item
                </button>&nbsp;&nbsp;&nbsp;
                <button className="tw-bg-secondary btn btn-pod tw-py-3 tw-rounded-lg tw-mt-6 tw-text-white tw-pr-5 tw-pl-5 btn-sm tw-text-sm"
                        onClick={(cta) => this.buttonCTA(cta,`/seller/${alias}`)}>
                  Continue Shopping &nbsp;&nbsp;
                  <img
                    src="/images/icons/right.svg"
                    alt="shop"
                    className="tw-text-secondary size-24px"
                  />
                </button>
              </div>
              {/*<span style={{cursor: 'pointer'}} className="tw-text-secondary tw-py-3 tw-mt-6" onClick={(cta) => this.buttonCTA(cta,`/seller/${alias}`)}>Continue Shopping</span>*/}
            </div>
          </div>
        </div>
      </AppContent>
    )
  }

}
